<result>
  <p>{ props.result }</p>
  <a href="#login" if="{ !isRegisterSuccess() }">
    <i class="fas fa-angle-double-left"></i>ログイン画面へ戻る
  </a>
  <script>
    import { router } from '@riotjs/route';

    export default {
      onMounted(props) {
        if (props.result === '') {
          router.push('login');
        }
      },

      isRegisterSuccess() {
        return this.props.result == '新規登録に成功しました。'
          || this.props.result == 'メールアドレスに新規登録用のメールを送信しました。';
      }
    };
  </script>
</result>